import { render, staticRenderFns } from "./AddNewWithdrawal.vue?vue&type=template&id=36b58a05"
import script from "./AddNewWithdrawal.vue?vue&type=script&lang=js"
export * from "./AddNewWithdrawal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports